<template>
  <div class="watchCenterPage">
    <leftNav :navarr="navarr" />
    <div class="main-center">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Bus from "utils/bus.js";
import Axios from "@/utils/Axios";
import Vue from "vue";
import leftNav from "../../components/leftNav";

export default {
  name: "watchCenterPage",
  data() {
    return {
      navarr: [
        { name: "设备管理", icon: require("@/assets/leftnav/deviceMsg.png") },
        { name: "设备运维", icon: require("@/assets/leftnav/devicePM.png") },
      ],
    };
  },
  methods: {},
  mounted() {},
  watch: {},
  components: {
    leftNav,
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.watchCenterPage {
  height: 100%;
  overflow: auto;
}
.main-center {
  width: calc(100% - 240px);

  height: 100%;
  display: inline-block;
  vertical-align: top;
  background-color: #ecf0f6;
  padding: 20px 24px;
  overflow: auto;
}
</style>
